import { render, staticRenderFns } from "./SpeakersBlockListItem.vue?vue&type=template&id=e8a2cece"
import script from "./SpeakersBlockListItem.vue?vue&type=script&lang=ts"
export * from "./SpeakersBlockListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports